// replacement of: vendor/imatic/vsem-design/assets/polyfills.js
// as it includes babel-polyfill, which is already included ant cannot be included twice
import AnimationFrame from 'animation-frame';
AnimationFrame.shim();

import 'whatwg-fetch';
import autosize from 'autosize';

require('iframe-resizer/js/iframeResizer.contentWindow.js');
require('./../../src/Imatic/Bundle/CommunicatorBundle/Resources/public/js/communicator.js');
require('./../../src/AppBundle/Resources/public/js/app.js');

 if ('serviceWorker' in navigator) {
   window.addEventListener('load', () => {
     navigator.serviceWorker.register('/assets/service-worker.js')
        .catch(registrationError => {
            console.error('SW registration failed: ', registrationError);
        });
   });
 }

$(function() {
    function action($checkbox) {
        return $checkbox.is(':checked') ? 'show' : 'hide';
    }

    function getCheckbox() {
        return $('#message_template_isAutomaticReply');
    }

    function getCollapsible() {
        return $('#autoReplySettingsCollapse');
    }

    getCheckbox().on('change', function() {
        const $checkbox = $(this);
        getCollapsible().collapse(action($checkbox));
    });
    getCollapsible().collapse(action(getCheckbox()));
});

window.appOpenDropdown = function(e) {
    const $container = $(e.currentTarget).parent();
    $container.toggleClass('open');

    const $dropdown = $container.find('ul');
    const maxHeight = $(document).height() - $dropdown.offset().top;
    $dropdown.css('max-height', maxHeight);
    $dropdown.css('overflow', 'auto');
};

window.addEventListener('load', () => {
    autosize(document.querySelectorAll('textarea'));
});
